






















import {
  defineComponent,
  getCurrentInstance,
  ref,
  PropType,
} from '@vue/composition-api'
import { ApolloError, NetworkStatus } from 'apollo-client'

import CustomSelectTemplate from '@/components/organisms/h/item/hierarchy/CustomSelectTemplate.vue'
import {
  emitHierarchySelect,
  itemHierarchyType,
  emitHierarchySearch,
  emitCustomSelectSelect,
} from '@/types/entities'
import {
  StoresDocument,
  AllStoreMstEdge,
  Where,
} from '@/types/generated/graphql'
import { MAX_COUNT } from '@/utils/constant'
import Toast, { genNotifyMessage } from '@/utils/toast'

export default defineComponent({
  components: { CustomSelectTemplate },
  props: {
    where: {
      type: Array as PropType<Where[]>,
      default: () => [],
    },
    itemHierarchyType: {
      type: String as PropType<itemHierarchyType>,
      default: '',
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  apollo: {
    stores: {
      query: StoresDocument,
      variables() {
        return this.searchCond
      },
      skip: true,
      fetchPolicy: 'cache-and-network',
      error(e: ApolloError) {
        Toast.error(this, { message: genNotifyMessage('e.list', 'store', e) })
      },
    },
  },
  created() {
    this.$apollo.queries.stores.skip = false
    this.isSkipQuery = false
  },
  data() {
    return {
      stores: { edges: [] }, // 店舗マスタ
      // 表示を制御するためのフラグ（データを触ると想定しない挙動となるため用意した）
      isSkipQuery: true,
      totalCount: 0,
      first: MAX_COUNT,
    }
  },
  computed: {
    isLoading() {
      return this.$apollo.queries.stores.loading
    },
    storeList() {
      // 店舗一覧
      return this.stores.edges.map((ele: AllStoreMstEdge) => {
        return {
          value: ele.node?.storeCd,
          text: ele.node?.storeName,
          key: ele.node?.storeCd,
        }
      })
    },
    searchCond(props: any) {
      return {
        where: props.where,
        orderBy: [],
        first: this.first,
      }
    },
  },
  watch: {
    where(newVal) {
      this.resetFirst()
    },
    stores(data) {
      this.totalCount = this.stores.totalCount
    },
  },
  methods: {
    changeSelected(emitParams: emitCustomSelectSelect) {
      const setectedMetaInfo = this.stores.edges.filter(
        (ele: AllStoreMstEdge) => {
          const key = ele.node?.storeCd
          if (key) {
            for (const selKey of emitParams.keyList) {
              if (selKey.indexOf(key) !== -1) {
                return true
              }
            }
          }
        }
      )
      const params: emitHierarchySelect = {
        itemHierarchyType: 'Store',
        selected: emitParams.selectList,
        selectedCount: emitParams.selectedCount,
        setectedMetaInfo: setectedMetaInfo,
      }
      this.$emit('change-selected', params)
    },
    onSearchWord(params: emitHierarchySearch) {
      console.log('search-word')
      this.$emit('search-word', params)
    },
    onSearch(params: emitHierarchySearch) {
      this.$emit('search', params)
    },
    countOverOk(params: any) {
      this.first = params
    },
    resetFirst() {
      this.first = MAX_COUNT
    },
  },
})
